define("settings/components/subscription-overview", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/utils", "@ember/service", "ember-concurrency-decorators", "lodash", "@glimmer/tracking", "later/utils/constants"], function (_exports, _component, _templateFactory, _component2, _object, _utils, _service, _emberConcurrencyDecorators, _lodash, _tracking, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Section::ItemWrapper>
    <Section::ItemDetails
      class="tAC--plan"
      data-test-id="overview"
      {{did-insert (perform this.getDiscount)}}
    >
      <PlanImage
        @shouldShowImage={{this.isOnLegacyPlan}}
        @planType={{this.subscriptionPlan.planType}}
      />
      <div class="tAC--plan__detail">
        {{#if (or this.hasActiveCancelledSubscription this.hasUpcomingDowngrade)}}
          <p class="u--text--lg u--m__b__sm" data-test-id="downgrade plan name">
            <span class="u--text--light u--text--strike">
              {{this.name}}
            </span>
  
            {{this.upcomingPlanName}}
  
            {{#if this.currentAccount.hasActiveTrial}}
              <span class="tAC--plan__label u--float--right" data-test-id="downgrade trial days">
                {{t "account.trial_plan_count" count=this.currentAccount.trialDaysRemaining}}
              </span>
            {{/if}}
          </p>
          {{#if this.getDiscount.isRunning}}
            <p>
              {{html-safe (t "account.overview.subscription_overview.loading")}}
            </p>
          {{else if (and this.hasActiveCancelledSubscription this.currentAccount.hasActiveTrial)}}
            <p data-test-id="trial cancelled">
              {{html-safe
                (t "account.overview.subscription_overview.cancelled_trial"
                  planName=this.name
                  count=this.currentAccount.trialDaysRemaining
                  date=this.subscription.activeUntil
                )
              }}
            </p>
          {{else if (and this.hasUpcomingDowngrade this.currentAccount.hasActiveTrial)}}
            {{#if this.hasDiscount}}
              <p data-test-id="trial downgraded discount">
                {{html-safe
                  (t "account.overview.subscription_overview.downgraded_trial_discounted"
                    count=this.currentAccount.trialDaysRemaining
                    interval=this.upcomingPlan.interval
                    date=this.subscription.activeUntil
                    planName=this.name
                    upcomingPlanName=this.upcomingPlanName
                    futureAmount=(format-currency this.discount.futureAmountDiscounted)
                    discount=(format-currency this.discountAmount))
                }}
              </p>
            {{else}}
              <p data-test-id="trial downgraded">
                {{html-safe
                  (t "account.overview.subscription_overview.downgraded_trial"
                    count=this.currentAccount.trialDaysRemaining
                    date=this.subscription.activeUntil
                    planName=this.name
                    upcomingPlanName=this.upcomingPlanName
                    amount=(format-currency this.nextAmountCharged)
                    interval=this.upcomingPlan.interval
                  )
                }}
              </p>
            {{/if}}
          {{else}}
            <p data-test-id="downgraded">
              {{html-safe
                (t "account.overview.subscription_overview.active_until"
                  planName=this.name
                  upcomingPlanName=this.upcomingPlanName
                  date=this.subscription.activeUntil)
              }}
            </p>
          {{/if}}
        {{else}}
          <p data-test-id="plan name" class="u--text--lg u--m__b__sm">
            {{this.name}}
            {{#if this.currentAccount.hasActiveTrial}}
              <span class="tAC--plan__label u--float--right" data-test-id="trial days">
                {{t "account.trial_plan_count" count=this.currentAccount.trialDaysRemaining}}
              </span>
            {{/if}}
          </p>
          {{#if this.getDiscount.isRunning}}
            <p>
              {{html-safe (t "account.overview.subscription_overview.loading")}}
            </p>
          {{else if this.isEligibleForTrial}}
            <p data-test-id="trial eligible">
              {{html-safe (t "account.overview.subscription_overview.trial_details")}}
            </p>
          {{else if (and this.isPaidPlan (not this.hasCustomPlan))}}
            {{#if this.currentAccount.hasActiveTrial}}
              {{#if this.hasDiscount}}
                <p data-test-id="trial discount">
                  {{html-safe
                    (t "account.overview.subscription_overview.renewal_date_trial_discounted"
                      count=this.currentAccount.trialDaysRemaining
                      interval=(if
                        this.hasUpcomingIntervalDowngrade
                        this.upcomingPlan.interval
                        this.subscriptionPlan.interval
                      )
                      date=this.renewalDate
                      planName=this.name
                      futureAmount=(format-currency this.discount.futureAmountDiscounted)
                      discount=(format-currency this.discountAmount))
                  }}
                </p>
              {{else}}
                <p data-test-id="trial renewal date">
                  {{html-safe
                    (t "account.overview.subscription_overview.renewal_date_trial"
                      count=this.currentAccount.trialDaysRemaining
                      interval=(if
                        this.hasUpcomingIntervalDowngrade
                        this.upcomingPlan.interval
                        this.subscriptionPlan.interval
                      )
                      date=this.renewalDate
                      planName=this.name
                      amount=(format-currency this.nextAmountCharged))
                  }}
                </p>
              {{/if}}
            {{else if (and this.hasDiscount (not this.hasDowngradedAfterDiscountRemoval))}}
              <p data-test-id="discount">
                {{html-safe
                  (t "account.overview.subscription_overview.renewal_date_discounted"
                    interval=this.subscriptionPlan.normalizedInterval
                    date=this.renewalDate
                    futureAmount=(format-currency this.discount.futureAmountDiscounted)
                    discount=(format-currency this.discountAmount))
                }}
              </p>
            {{else}}
              <p data-test-id="renewal date">
                {{html-safe
                  (t "account.overview.subscription_overview.renewal_date"
                    interval=this.subscriptionPlan.normalizedInterval
                    date=this.renewalDate
                    amount=(format-currency this.nextAmountCharged))
                }}
              </p>
            {{/if}}
          {{/if}}
        {{/if}}
      </div>
    </Section::ItemDetails>
    <SubscriptionOverview::Action
      @canUpgrade={{this.canUpgrade}}
      @canReactivatePlan={{this.canReactivatePlan}}
      @subscription={{this.subscription}}
      @isAccountOwner={{this.isAccountOwner}}
      @hasActiveCancelledSubscription={{this.hasActiveCancelledSubscription}}
      @hasActiveTrial={{this.currentAccount.hasActiveTrial}}
      @isNewSubscriber={{this.isNewSubscriber}}
      @trackChangePlan={{this.trackChangePlan}}
      @trackClickedTraining={{this.trackClickedTraining}}
      @reactivatePlan={{this.reactivatePlan}}
      @cancelTrial={{this.cancelTrial}}
    />
  </Section::ItemWrapper>
  
  */
  {
    "id": "l2Wwd17y",
    "block": "[[[8,[39,0],null,null,[[\"default\"],[[[[1,\"\\n  \"],[8,[39,1],[[24,0,\"tAC--plan\"],[24,\"data-test-id\",\"overview\"],[4,[38,2],[[28,[37,3],[[30,0,[\"getDiscount\"]]],null]],null]],null,[[\"default\"],[[[[1,\"\\n    \"],[8,[39,4],null,[[\"@shouldShowImage\",\"@planType\"],[[30,0,[\"isOnLegacyPlan\"]],[30,0,[\"subscriptionPlan\",\"planType\"]]]],null],[1,\"\\n    \"],[10,0],[14,0,\"tAC--plan__detail\"],[12],[1,\"\\n\"],[41,[28,[37,6],[[30,0,[\"hasActiveCancelledSubscription\"]],[30,0,[\"hasUpcomingDowngrade\"]]],null],[[[1,\"        \"],[10,2],[14,0,\"u--text--lg u--m__b__sm\"],[14,\"data-test-id\",\"downgrade plan name\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"u--text--light u--text--strike\"],[12],[1,\"\\n            \"],[1,[30,0,[\"name\"]]],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[1,[30,0,[\"upcomingPlanName\"]]],[1,\"\\n\\n\"],[41,[30,0,[\"currentAccount\",\"hasActiveTrial\"]],[[[1,\"            \"],[10,1],[14,0,\"tAC--plan__label u--float--right\"],[14,\"data-test-id\",\"downgrade trial days\"],[12],[1,\"\\n              \"],[1,[28,[35,7],[\"account.trial_plan_count\"],[[\"count\"],[[30,0,[\"currentAccount\",\"trialDaysRemaining\"]]]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\"],[41,[30,0,[\"getDiscount\",\"isRunning\"]],[[[1,\"          \"],[10,2],[12],[1,\"\\n            \"],[1,[28,[35,8],[[28,[37,7],[\"account.overview.subscription_overview.loading\"],null]],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,9],[[30,0,[\"hasActiveCancelledSubscription\"]],[30,0,[\"currentAccount\",\"hasActiveTrial\"]]],null],[[[1,\"          \"],[10,2],[14,\"data-test-id\",\"trial cancelled\"],[12],[1,\"\\n            \"],[1,[28,[35,8],[[28,[37,7],[\"account.overview.subscription_overview.cancelled_trial\"],[[\"planName\",\"count\",\"date\"],[[30,0,[\"name\"]],[30,0,[\"currentAccount\",\"trialDaysRemaining\"]],[30,0,[\"subscription\",\"activeUntil\"]]]]]],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,9],[[30,0,[\"hasUpcomingDowngrade\"]],[30,0,[\"currentAccount\",\"hasActiveTrial\"]]],null],[[[41,[30,0,[\"hasDiscount\"]],[[[1,\"            \"],[10,2],[14,\"data-test-id\",\"trial downgraded discount\"],[12],[1,\"\\n              \"],[1,[28,[35,8],[[28,[37,7],[\"account.overview.subscription_overview.downgraded_trial_discounted\"],[[\"count\",\"interval\",\"date\",\"planName\",\"upcomingPlanName\",\"futureAmount\",\"discount\"],[[30,0,[\"currentAccount\",\"trialDaysRemaining\"]],[30,0,[\"upcomingPlan\",\"interval\"]],[30,0,[\"subscription\",\"activeUntil\"]],[30,0,[\"name\"]],[30,0,[\"upcomingPlanName\"]],[28,[37,10],[[30,0,[\"discount\",\"futureAmountDiscounted\"]]],null],[28,[37,10],[[30,0,[\"discountAmount\"]]],null]]]]],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[10,2],[14,\"data-test-id\",\"trial downgraded\"],[12],[1,\"\\n              \"],[1,[28,[35,8],[[28,[37,7],[\"account.overview.subscription_overview.downgraded_trial\"],[[\"count\",\"date\",\"planName\",\"upcomingPlanName\",\"amount\",\"interval\"],[[30,0,[\"currentAccount\",\"trialDaysRemaining\"]],[30,0,[\"subscription\",\"activeUntil\"]],[30,0,[\"name\"]],[30,0,[\"upcomingPlanName\"]],[28,[37,10],[[30,0,[\"nextAmountCharged\"]]],null],[30,0,[\"upcomingPlan\",\"interval\"]]]]]],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]]]],[]],[[[1,\"          \"],[10,2],[14,\"data-test-id\",\"downgraded\"],[12],[1,\"\\n            \"],[1,[28,[35,8],[[28,[37,7],[\"account.overview.subscription_overview.active_until\"],[[\"planName\",\"upcomingPlanName\",\"date\"],[[30,0,[\"name\"]],[30,0,[\"upcomingPlanName\"]],[30,0,[\"subscription\",\"activeUntil\"]]]]]],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]],[]]]],[]]]],[]],[[[1,\"        \"],[10,2],[14,\"data-test-id\",\"plan name\"],[14,0,\"u--text--lg u--m__b__sm\"],[12],[1,\"\\n          \"],[1,[30,0,[\"name\"]]],[1,\"\\n\"],[41,[30,0,[\"currentAccount\",\"hasActiveTrial\"]],[[[1,\"            \"],[10,1],[14,0,\"tAC--plan__label u--float--right\"],[14,\"data-test-id\",\"trial days\"],[12],[1,\"\\n              \"],[1,[28,[35,7],[\"account.trial_plan_count\"],[[\"count\"],[[30,0,[\"currentAccount\",\"trialDaysRemaining\"]]]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\"],[41,[30,0,[\"getDiscount\",\"isRunning\"]],[[[1,\"          \"],[10,2],[12],[1,\"\\n            \"],[1,[28,[35,8],[[28,[37,7],[\"account.overview.subscription_overview.loading\"],null]],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isEligibleForTrial\"]],[[[1,\"          \"],[10,2],[14,\"data-test-id\",\"trial eligible\"],[12],[1,\"\\n            \"],[1,[28,[35,8],[[28,[37,7],[\"account.overview.subscription_overview.trial_details\"],null]],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,9],[[30,0,[\"isPaidPlan\"]],[28,[37,11],[[30,0,[\"hasCustomPlan\"]]],null]],null],[[[41,[30,0,[\"currentAccount\",\"hasActiveTrial\"]],[[[41,[30,0,[\"hasDiscount\"]],[[[1,\"              \"],[10,2],[14,\"data-test-id\",\"trial discount\"],[12],[1,\"\\n                \"],[1,[28,[35,8],[[28,[37,7],[\"account.overview.subscription_overview.renewal_date_trial_discounted\"],[[\"count\",\"interval\",\"date\",\"planName\",\"futureAmount\",\"discount\"],[[30,0,[\"currentAccount\",\"trialDaysRemaining\"]],[52,[30,0,[\"hasUpcomingIntervalDowngrade\"]],[30,0,[\"upcomingPlan\",\"interval\"]],[30,0,[\"subscriptionPlan\",\"interval\"]]],[30,0,[\"renewalDate\"]],[30,0,[\"name\"]],[28,[37,10],[[30,0,[\"discount\",\"futureAmountDiscounted\"]]],null],[28,[37,10],[[30,0,[\"discountAmount\"]]],null]]]]],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[1,\"              \"],[10,2],[14,\"data-test-id\",\"trial renewal date\"],[12],[1,\"\\n                \"],[1,[28,[35,8],[[28,[37,7],[\"account.overview.subscription_overview.renewal_date_trial\"],[[\"count\",\"interval\",\"date\",\"planName\",\"amount\"],[[30,0,[\"currentAccount\",\"trialDaysRemaining\"]],[52,[30,0,[\"hasUpcomingIntervalDowngrade\"]],[30,0,[\"upcomingPlan\",\"interval\"]],[30,0,[\"subscriptionPlan\",\"interval\"]]],[30,0,[\"renewalDate\"]],[30,0,[\"name\"]],[28,[37,10],[[30,0,[\"nextAmountCharged\"]]],null]]]]],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]]]],[]],[[[41,[28,[37,9],[[30,0,[\"hasDiscount\"]],[28,[37,11],[[30,0,[\"hasDowngradedAfterDiscountRemoval\"]]],null]],null],[[[1,\"            \"],[10,2],[14,\"data-test-id\",\"discount\"],[12],[1,\"\\n              \"],[1,[28,[35,8],[[28,[37,7],[\"account.overview.subscription_overview.renewal_date_discounted\"],[[\"interval\",\"date\",\"futureAmount\",\"discount\"],[[30,0,[\"subscriptionPlan\",\"normalizedInterval\"]],[30,0,[\"renewalDate\"]],[28,[37,10],[[30,0,[\"discount\",\"futureAmountDiscounted\"]]],null],[28,[37,10],[[30,0,[\"discountAmount\"]]],null]]]]],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[10,2],[14,\"data-test-id\",\"renewal date\"],[12],[1,\"\\n              \"],[1,[28,[35,8],[[28,[37,7],[\"account.overview.subscription_overview.renewal_date\"],[[\"interval\",\"date\",\"amount\"],[[30,0,[\"subscriptionPlan\",\"normalizedInterval\"]],[30,0,[\"renewalDate\"]],[28,[37,10],[[30,0,[\"nextAmountCharged\"]]],null]]]]],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]]]],[]]],[1,\"        \"]],[]],null]],[]]]],[]]]],[]]],[1,\"    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n  \"],[8,[39,12],null,[[\"@canUpgrade\",\"@canReactivatePlan\",\"@subscription\",\"@isAccountOwner\",\"@hasActiveCancelledSubscription\",\"@hasActiveTrial\",\"@isNewSubscriber\",\"@trackChangePlan\",\"@trackClickedTraining\",\"@reactivatePlan\",\"@cancelTrial\"],[[30,0,[\"canUpgrade\"]],[30,0,[\"canReactivatePlan\"]],[30,0,[\"subscription\"]],[30,0,[\"isAccountOwner\"]],[30,0,[\"hasActiveCancelledSubscription\"]],[30,0,[\"currentAccount\",\"hasActiveTrial\"]],[30,0,[\"isNewSubscriber\"]],[30,0,[\"trackChangePlan\"]],[30,0,[\"trackClickedTraining\"]],[30,0,[\"reactivatePlan\"]],[30,0,[\"cancelTrial\"]]]],null],[1,\"\\n\"]],[]]]]],[1,\"\\n\"]],[],false,[\"section/item-wrapper\",\"section/item-details\",\"did-insert\",\"perform\",\"plan-image\",\"if\",\"or\",\"t\",\"html-safe\",\"and\",\"format-currency\",\"not\",\"subscription-overview/action\"]]",
    "moduleName": "settings/components/subscription-overview.hbs",
    "isStrictMode": false
  });

  let SubscriptionOverview = (_class = class SubscriptionOverview extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "cancellation", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "settings", _descriptor4, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor5, this);

      _initializerDefineProperty(this, "discount", _descriptor6, this);
    }

    get baseName() {
      var _this$subscription;

      return ((_this$subscription = this.subscription) === null || _this$subscription === void 0 ? void 0 : _this$subscription.name) || 'Free';
    }

    get canReactivatePlan() {
      return this.subscriptions.subscriptionPlan.active;
    }

    get canUpgrade() {
      return this.subscriptions.canUpgrade;
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get discountAmount() {
      var _this$discount;

      const discountAppliesPlanOnly = (0, _utils.isPresent)((_this$discount = this.discount) === null || _this$discount === void 0 ? void 0 : _this$discount.appliesTo);

      if (discountAppliesPlanOnly) {
        var _this$upcomingPlan$am, _this$upcomingPlan, _this$discount$amount;

        const planAmount = (_this$upcomingPlan$am = (_this$upcomingPlan = this.upcomingPlan) === null || _this$upcomingPlan === void 0 ? void 0 : _this$upcomingPlan.amount) !== null && _this$upcomingPlan$am !== void 0 ? _this$upcomingPlan$am : this.subscriptionPlan.amount;
        const planDiscount = (_this$discount$amount = this.discount.amountOff) !== null && _this$discount$amount !== void 0 ? _this$discount$amount : planAmount * (this.discount.percentOff / 100);
        return Math.min(planAmount, planDiscount);
      }

      return this.discount.discountAmount;
    }

    get hasActiveCancelledSubscription() {
      return this.currentAccount.hasActiveCancelledSubscription;
    }

    get hasCustomPlan() {
      return this.currentAccount.hasCustomPlan;
    }

    get hasDiscount() {
      var _this$discount2, _this$discount$applie, _this$subscriptionPla, _this$discount$applie2, _this$upcomingPlan2, _this$discount3;

      const discountApplies = !((0, _utils.isPresent)((_this$discount2 = this.discount) === null || _this$discount2 === void 0 ? void 0 : _this$discount2.appliesTo) && !((_this$discount$applie = this.discount.appliesTo.products) !== null && _this$discount$applie !== void 0 && _this$discount$applie.includes((_this$subscriptionPla = this.subscriptionPlan) === null || _this$subscriptionPla === void 0 ? void 0 : _this$subscriptionPla.stripeProductId)) && !((_this$discount$applie2 = this.discount.appliesTo.products) !== null && _this$discount$applie2 !== void 0 && _this$discount$applie2.includes((_this$upcomingPlan2 = this.upcomingPlan) === null || _this$upcomingPlan2 === void 0 ? void 0 : _this$upcomingPlan2.stripeProductId)));
      return (0, _utils.isPresent)((_this$discount3 = this.discount) === null || _this$discount3 === void 0 ? void 0 : _this$discount3.futureAmountDiscounted) && discountApplies;
    }

    get hasDowngradedAfterDiscountRemoval() {
      const hasIntervalDowngrade = this.hasUpcomingIntervalDowngrade && this.subscription.planModifiedTime >= _constants.DOWNGRADE_DISCOUNT_REMOVAL_CUTOFF;
      const hasSocialSetDowngrade = this.hasUpcomingSocialSetDowngrade && this.subscription.socialSetsModifiedTime >= _constants.DOWNGRADE_DISCOUNT_REMOVAL_CUTOFF;
      const hasUserDowngrade = this.hasUpcomingUserDowngrade && this.subscription.usersModifiedTime >= _constants.DOWNGRADE_DISCOUNT_REMOVAL_CUTOFF;
      return hasIntervalDowngrade || hasSocialSetDowngrade || hasUserDowngrade;
    }

    get hasUpcomingDowngrade() {
      return this.subscriptions.hasUpcomingDowngrade;
    }

    get hasUpcomingIntervalDowngrade() {
      return this.subscriptions.hasUpcomingIntervalDowngrade;
    }

    get hasUpcomingSocialSetDowngrade() {
      var _this$subscription$up;

      const currentQuantity = this.subscription.additionalSocialSets;
      const upcomingQuantity = (_this$subscription$up = this.subscription.upcomingSocialSetChanges) === null || _this$subscription$up === void 0 ? void 0 : _this$subscription$up.quantity;
      return (0, _utils.isPresent)(currentQuantity) && (0, _utils.isPresent)(upcomingQuantity) && currentQuantity > upcomingQuantity;
    }

    get hasUpcomingUserDowngrade() {
      var _this$subscription$up2;

      const currentQuantity = this.subscription.additionalUsers;
      const upcomingQuantity = (_this$subscription$up2 = this.subscription.upcomingUserChanges) === null || _this$subscription$up2 === void 0 ? void 0 : _this$subscription$up2.quantity;
      return (0, _utils.isPresent)(currentQuantity) && (0, _utils.isPresent)(upcomingQuantity) && currentQuantity > upcomingQuantity;
    }

    get hasVIPPlan() {
      return !this.isStripeCustomer && !(0, _lodash.isEmpty)(this.subscription);
    }

    get isAccountOwner() {
      return this.settings.isAccountOwner;
    }

    get isEligibleForTrial() {
      return this.currentAccount.canTrialPlan;
    }

    get isOnLegacyPlan() {
      return this.currentAccount.isOnLegacyPlan;
    }

    get isStripeCustomer() {
      return this.currentAccount.isStripeCustomer;
    }

    get isNewSubscriber() {
      return this.settings.isNewSubscriber;
    }

    get isPaidPlan() {
      return this.subscriptions.isPaid;
    }

    get name() {
      if (this.currentAccount.hasActiveTrial) {
        return this.intl.t('account.trial_plan_name', {
          name: this.baseName
        });
      } else if (this.hasVIPPlan) {
        return this.intl.t('account.subscription.vip_plan');
      } else if (this.hasCustomPlan) {
        return this.intl.t('account.subscription.custom_plan');
      }

      return this.baseName;
    }

    get planType() {
      return this.subscriptions.planType;
    }

    get renewalDate() {
      var _this$subscription2;

      return (_this$subscription2 = this.subscription) === null || _this$subscription2 === void 0 ? void 0 : _this$subscription2.renewalDate;
    }

    get subscription() {
      return this.subscriptions.subscription;
    }

    get subscriptionPlan() {
      return this.subscriptions.subscriptionPlan;
    }

    get upcomingPlan() {
      return this.subscriptions.upcomingSubscriptionPlan;
    }

    get upcomingPlanName() {
      if (this.hasUpcomingDowngrade || this.hasActiveCancelledSubscription) {
        var _this$upcomingPlan3;

        return ((_this$upcomingPlan3 = this.upcomingPlan) === null || _this$upcomingPlan3 === void 0 ? void 0 : _this$upcomingPlan3.name) || 'Free';
      }

      return null;
    }

    get nextAmountCharged() {
      var _this$discount4, _this$discount5, _this$discount6;

      return (0, _utils.isPresent)((_this$discount4 = this.discount) === null || _this$discount4 === void 0 ? void 0 : _this$discount4.futureAmountDiscounted) ? (_this$discount5 = this.discount) === null || _this$discount5 === void 0 ? void 0 : _this$discount5.futureAmountDiscounted : (_this$discount6 = this.discount) === null || _this$discount6 === void 0 ? void 0 : _this$discount6.futureAmount;
    }

    *getDiscount() {
      this.discount = yield this.subscriptions.getSubscriptionDiscount();
    }

    *reactivatePlan() {
      yield this.settings.reactivateCancelledPlan.perform(this.subscription);
      yield this.getDiscount.perform();
    }

    cancelTrial() {
      this.cancellation.startCancellationFlow.perform('subscription');
    }

    trackChangePlan() {
      this.settings.trackChangePlan.perform(this.subscription);
    }

    trackClickedTraining() {
      this.settings.trackClickedTraining.perform(this.subscription);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cancellation", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "discount", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "getDiscount", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "getDiscount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reactivatePlan", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "reactivatePlan"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelTrial", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelTrial"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackChangePlan", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackChangePlan"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackClickedTraining", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackClickedTraining"), _class.prototype)), _class);
  _exports.default = SubscriptionOverview;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SubscriptionOverview);
});